$().ready(function () {
	$.nette.init();
	tooltipInit();
	scrollbarInit();
	minimizeSidebar();
	//openDropdown();
	passwordStrengthMeterInit();
	inputMaskInit();
	datetimePickerInit();
	selectInit();
	select2Init();
	colorPickerInit();
	tagsInputInit();
	datetimePickerInit();
	tinyMceInit();
	tinyMceSimpleInit();
	tinyMceWitFileManagerDmsInit();
	tinyMceWitFileManagerTrainingsInit();
	tinyMceWitFileManagerElearningInit();
	stickyTableHeadersInit();
	calculateCarPrice();
	globalCarTypeahead();

	$(window).on('resize', function(){
		stickyTableHeadersInit();
	});
});


function scrollbarInit() {
	var perfectScrollbar = new PerfectScrollbar('.sidebar-nav', {
		wheelSpeed: 2,
		suppressScrollX: true
	});

	setTimeout(function () {
		perfectScrollbar.update();
	}, 500);
}


function tooltipInit() {
	$('[data-toggle="tooltip"]').tooltip();
}


function minimizeSidebar() {
	$('.sidebar-minimizer').click(function (e) {
		e.preventDefault();

		var minimizedClass = 'sidebar-minimized';
		var mainContentSelector = '.main-content';

		if ($(mainContentSelector).hasClass(minimizedClass)) {
			$(mainContentSelector).removeClass(minimizedClass);
			Cookies.remove('sidebar-minimized');
		} else {
			$(mainContentSelector).addClass(minimizedClass);
			Cookies.set('sidebar-minimized', {expires: 365});
		}
	});
}


function openDropdown() {
	$('.sidebar-nav .nav-dropdown > .nav-link').click(function (e) {
		e.preventDefault();

		var openClass = 'open';

		if ($(this).parent().hasClass(openClass)) {
			$(this).parent().removeClass(openClass);
		} else {
			$(this).parent().addClass(openClass);
		}

		var perfectScrollbar = new PerfectScrollbar('.sidebar-nav', {
			wheelSpeed: 2,
			suppressScrollX: true
		});

		setTimeout(function () {
			perfectScrollbar.update();
		}, 500);
	});
}


function passwordStrengthMeterInit() {
	var options = {};
	options.common = {
		minChar: 5
	};
	options.ui = {
		container: "#pwd-container",
		viewports: {
			progress: ".pwstrength-viewport-progress"
		},
		showVerdictsInsideProgressBar: true
	};
	$('.pwstrength').pwstrength(options);
}


function inputMaskInit() {
	$('.number').mask(
		'# ##0',
		{
			reverse: true
		}
	);

	$('.number-percent').mask(
		'09,09',
		{
			placeholder: '__,__'
		}
	);

	$('.phone').mask(
		'+000 000 000 000',
		{
			placeholder: '+___ ___ ___ ___'
		}
	);

	$('.phone3x').mask(
		'+000 000 000 000, +000 000 000 000, +000 000 000 000',
		{
			placeholder: '+___ ___ ___ ___, +___ ___ ___ ___, +___ ___ ___ ___'
		}
	);

	$('.date').mask(
		'A0. A0. B000',
		{
			placeholder: '__.__.____',
			translation: {
				'A': {
					pattern: /[0-3]/
				},
				'B': {
					pattern: /[1-2]/
				}
			}
		}
	);

	$('.date-time').mask(
		'A0. A0. B000 H0:M0',
		{
			placeholder: '__.__.____ __:__',
			translation: {
				'A': {
					pattern: /[0-3]/
				},
				'B': {
					pattern: /[1-2]/
				},
				'H': {
					pattern: /[0-2]/
				},
				'M': {
					pattern: /[0-5]/
				}
			}
		}
	);

	$('.time').mask(
		'H0:M0',
		{
			placeholder: '__:__',
			translation: {
				'H': {
					pattern: /[0-2]/
				},
				'M': {
					pattern: /[0-5]/
				}
			}
		}
	);

	$('.unlimited-time').mask(
		'000:M0',
		{
			reverse: true,
			placeholder: '___:__',
			translation: {
				'H': {
					pattern: /[0-2]/
				},
				'M': {
					pattern: /[0-5]/
				}
			}
		}
	);

}


function datetimePickerInit() {
	$('.time-picker').datetimepicker({
		format: 'HH:mm',
		locale: 'cs',
		keepOpen: false,
		keepInvalid: true
	});

	$('.date-picker').datetimepicker({
		format: 'DD. MM. YYYY',
		locale: 'cs',
		keepInvalid: true
	});

	$('.date-time-picker').datetimepicker({
		format: 'DD. MM. YYYY HH:mm',
		locale: 'cs',
		keepInvalid: true
	});
}


function selectInit() {
	$('.selectpicker').selectpicker({
		actionsBox: true,
		iconBase: 'fas',
		tickIcon: 'fa-check',
		countSelectedText: 'Vybrané {0} z {1}',
	});
}


function select2Init() {
	$('.select2').select2({
		width: '100%',
		minimumResultsForSearch: 10
	});
};



function colorPickerInit() {
	$('.color-picker').colorpicker({
		format: 'hex'
	});

	$('.color-picker').on('colorpickerChange', function(event) {
		if (event.color) {
			$('.color-picker .input-group-append .input-group-text i').css('background-color', event.color.toString());
		}
	});
};



function tagsInputInit() {
	$('.tags').tagsinput({
		trimValue: true,
		allowDuplicates: false,
		focusClass: 'focus'
	});
};


function datetimePickerInit() {
	$('.time-picker').datetimepicker({
		format: 'HH:mm',
		locale: 'cs',
		keepOpen: false,
		keepInvalid: true,
		icons: {
			time: 'far fa-clock',
			date: 'far fa-calendar',
			up: 'fas fa-arrow-up',
			down: 'fas fa-arrow-down',
			previous: 'fas fa-chevron-left',
			next: 'fas fa-chevron-right',
			today: 'fas fa-calendar-check',
			clear: 'far fa-trash-alt',
			close: 'far fa-times-circle'
		}
	});

	$('.date-picker').datetimepicker({
		format: 'DD. MM. YYYY',
		locale: 'cs',
		keepInvalid: true,
		icons: {
			time: 'far fa-clock',
			date: 'far fa-calendar',
			up: 'fas fa-arrow-up',
			down: 'fas fa-arrow-down',
			previous: 'fas fa-chevron-left',
			next: 'fas fa-chevron-right',
			today: 'fas fa-calendar-check',
			clear: 'far fa-trash-alt',
			close: 'far fa-times-circle'
		}
	});

	$('.date-time-picker').datetimepicker({
		format: 'DD. MM. YYYY HH:mm',
		locale: 'cs',
		keepInvalid: true,
		icons: {
			time: 'far fa-clock',
			date: 'far fa-calendar',
			up: 'fas fa-arrow-up',
			down: 'fas fa-arrow-down',
			previous: 'fas fa-chevron-left',
			next: 'fas fa-chevron-right',
			today: 'fas fa-calendar-check',
			clear: 'far fa-trash-alt',
			close: 'far fa-times-circle'
		}
	});
}


function tinyMceInit() {
	tinymce.init({
		selector: 'textarea.tinymce',
		plugins: [
			'advlist autolink link lists charmap hr table contextmenu directionality paste textcolor',
			'searchreplace wordcount visualblocks visualchars code insertdatetime nonbreaking image codemirror striptags'
		],
		toolbar: 'undo redo | paste pastetext | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link unlink image | table | striptags code',
		removed_menuitems: 'newdocument removeformat',
		codemirror: {
			indentOnInit: true,
			path: 'CodeMirror',
			config: {
				mode: 'htmlmixed',
				lineNumbers: true
			}
		},
		striptags_allowed: '<p><br><img><hr>',
		entity_encoding: "raw",
		valid_elements: '*[*]',
		relative_urls: false,
		content_css: "/css/tinymce.min.css?" + new Date().getTime(),
		language: 'cs'
	});
};


function tinyMceSimpleInit() {
	tinymce.init({
		selector: 'textarea.tinymce-simple',
		plugins: [
			'advlist autolink link lists hr contextmenu directionality paste textcolor',
			'searchreplace wordcount visualblocks code nonbreaking codemirror striptags'
		],
		toolbar: 'undo redo | paste pastetext | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link unlink | striptags code',
		removed_menuitems: 'newdocument removeformat',
		codemirror: {
			indentOnInit: true,
			path: 'CodeMirror',
			config: {
				mode: 'htmlmixed',
				lineNumbers: true
			}
		},
		striptags_allowed: '<p><br><img><hr>',
		entity_encoding: "raw",
		valid_elements: '*[*]',
		relative_urls: false,
		content_css: "/css/tinymce.min.css?" + new Date().getTime(),
		language: 'cs'
	});
};

function tinyMceWitFileManagerDmsInit() {
	tinymce.init({
		selector: 'textarea.tinymce-with-file-manager-dms',
		plugins: [
			'advlist autolink link lists charmap hr table contextmenu directionality paste textcolor',
			'searchreplace wordcount visualblocks visualchars code insertdatetime nonbreaking image codemirror striptags'
		],
		toolbar: 'undo redo | paste pastetext | styleselect fontsizeselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link unlink image | table | striptags code',
		removed_menuitems: 'newdocument removeformat',
		file_browser_callback: RoxyFileBrowserDms,
		codemirror: {
			indentOnInit: true,
			path: 'CodeMirror',
			config: {
				mode: 'htmlmixed',
				lineNumbers: true
			}
		},
		striptags_allowed: '<p><br><img><hr>',
		entity_encoding: "raw",
		valid_elements: '*[*]',
		relative_urls: false,
		content_css: "/css/tinymce.min.css?" + new Date().getTime(),
		language: 'cs'
	});
};


function tinyMceWitFileManagerTrainingsInit() {
	tinymce.init({
		selector: 'textarea.tinymce-with-file-manager-trainings',
		plugins: [
			'advlist autolink link lists charmap hr table contextmenu directionality paste textcolor',
			'searchreplace wordcount visualblocks visualchars code insertdatetime nonbreaking image codemirror striptags'
		],
		toolbar: 'undo redo | paste pastetext | styleselect fontsizeselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link unlink image | table | striptags code',
		removed_menuitems: 'newdocument removeformat',
		file_browser_callback: RoxyFileBrowserTrainings,
		codemirror: {
			indentOnInit: true,
			path: 'CodeMirror',
			config: {
				mode: 'htmlmixed',
				lineNumbers: true
			}
		},
		striptags_allowed: '<p><br><img><hr>',
		entity_encoding: "raw",
		valid_elements: '*[*]',
		relative_urls: false,
		content_css: "/css/tinymce.min.css?" + new Date().getTime(),
		language: 'cs'
	});
};


function tinyMceWitFileManagerElearningInit() {
	tinymce.init({
		selector: 'textarea.tinymce-with-file-manager-elearning',
		plugins: [
			'advlist autolink link lists hr table contextmenu directionality paste',
			'visualblocks visualchars code nonbreaking image codemirror striptags'
		],
		toolbar: 'paste pastetext | fontsizeselect bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link unlink image | table | striptags code',
		statusbar: false,
		file_browser_callback: RoxyFileBrowserElearning,
		codemirror: {
			indentOnInit: true,
			path: 'CodeMirror',
			config: {
				mode: 'htmlmixed',
				lineNumbers: true
			}
		},
		striptags_allowed: '<p><br><img><hr>',
		entity_encoding: "raw",
		valid_elements: '*[*]',
		relative_urls: false,
		content_css: "/css/tinymce.min.css?" + new Date().getTime(),
		language: 'cs'
	});
};

var RoxyFileBrowserDms = function (field_name, url, type, win) {
	var roxyFileman = '/assets/roxy-fileman-dms/index.html';
	if (roxyFileman.indexOf("?") < 0) {
		roxyFileman += "?type=" + type;
	}
	else {
		roxyFileman += "&type=" + type;
	}
	roxyFileman += '&input=' + field_name + '&value=' + win.document.getElementById(field_name).value;
	if (tinyMCE.activeEditor.settings.language) {
		roxyFileman += '&langCode=' + tinyMCE.activeEditor.settings.language;
	}
	tinyMCE.activeEditor.windowManager.open({
			file: roxyFileman,
			title: 'File Manager',
			width: 850,
			height: 550,
			resizable: "yes",
			plugins: "media",
			inline: "yes",
			close_previous: "no"
		},
		{
			window: win,
			input: field_name
		});
	return false;
};


var RoxyFileBrowserTrainings = function (field_name, url, type, win) {
	var roxyFileman = '/assets/roxy-fileman-trainings/index.html';
	if (roxyFileman.indexOf("?") < 0) {
		roxyFileman += "?type=" + type;
	}
	else {
		roxyFileman += "&type=" + type;
	}
	roxyFileman += '&input=' + field_name + '&value=' + win.document.getElementById(field_name).value;
	if (tinyMCE.activeEditor.settings.language) {
		roxyFileman += '&langCode=' + tinyMCE.activeEditor.settings.language;
	}
	tinyMCE.activeEditor.windowManager.open({
			file: roxyFileman,
			title: 'File Manager',
			width: 850,
			height: 550,
			resizable: "yes",
			plugins: "media",
			inline: "yes",
			close_previous: "no"
		},
		{
			window: win,
			input: field_name
		});
	return false;
};

var RoxyFileBrowserElearning = function (field_name, url, type, win) {
	var roxyFileman = '/assets/roxy-fileman-elearning/index.html';
	if (roxyFileman.indexOf("?") < 0) {
		roxyFileman += "?type=" + type;
	}
	else {
		roxyFileman += "&type=" + type;
	}
	roxyFileman += '&input=' + field_name + '&value=' + win.document.getElementById(field_name).value;
	if (tinyMCE.activeEditor.settings.language) {
		roxyFileman += '&langCode=' + tinyMCE.activeEditor.settings.language;
	}
	tinyMCE.activeEditor.windowManager.open({
			file: roxyFileman,
			title: 'File Manager',
			width: 850,
			height: 550,
			resizable: "yes",
			plugins: "media",
			inline: "yes",
			close_previous: "no"
		},
		{
			window: win,
			input: field_name
		});
	return false;
};


function stickyTableHeadersInit() {
	if ($(document).width() > 1600) {

		$('.datagrid table').stickyTableHeaders({
			marginTop: 50,
			zIndex: 1,

		});

		$.nette.ext({
			success: function (payload) {
				$('.datagrid table').stickyTableHeaders({
					marginTop: 50,
					zIndex: 1
				});
			}
		});
	} else {
		$('.datagrid table').stickyTableHeaders('destroy');
	}
};


function calculateCarPrice() {
	var priceInput = $('#frm-carForm-price_dealer');
	var discountInput = $('#frm-carForm-discount_dealer');
	var originalPriceInput = $('#frm-carForm-original_price_dealer');

	$('.calculate-price').on('click', function () {
		var discount = discountInput.val() === '' ? null : parseInt(discountInput.val().replace(/\s/g, ''));
		var originalPrice = originalPriceInput.val() === '' ? null : parseInt(originalPriceInput.val().replace(/\s/g, ''));
		if (discount && originalPrice) {
			priceInput.val((originalPrice - discount).toLocaleString());
		}
	});

	$('.calculate-discount').on('click', function () {
		var price = priceInput.val() === '' ? null : parseInt(priceInput.val().replace(/\s/g, ''));
		var originalPrice = originalPriceInput.val() === '' ? null : parseInt(originalPriceInput.val().replace(/\s/g, ''));
		if (price && originalPrice) {
			discountInput.val((originalPrice - price).toLocaleString());
		}
	});

	$('.calculate-original-price').on('click', function () {
		var price = priceInput.val() === '' ? null : parseInt(priceInput.val().replace(/\s/g, ''));
		var discount = discountInput.val() === '' ? null : parseInt(discountInput.val().replace(/\s/g, ''));
		if (price && discount) {
			originalPriceInput.val((price + discount).toLocaleString());
		}
	});
};


var bloodhoundCarExteriors = new Bloodhound({
	queryTokenizer: Bloodhound.tokenizers.whitespace,
	datumTokenizer: Bloodhound.tokenizers.whitespace,
	remote: {
		url: '/cars/json/?type=exterior&brand=Mitsubishi&query=%QUERY',
		wildcard: '%QUERY',
		filter: function (list) {
			return $.map(list.items, function (item) {
				return {name: item.text};
			});
		}
	}
});

var bloodhoundCarInteriors = new Bloodhound({
	queryTokenizer: Bloodhound.tokenizers.whitespace,
	datumTokenizer: Bloodhound.tokenizers.whitespace,
	remote: {
		url: '/cars/json/?type=interior&brand=Mitsubishi&query=%QUERY',
		wildcard: '%QUERY',
		filter: function (list) {
			return $.map(list.items, function (item) {
				return {name: item.text};
			});
		}
	}
});

var bloodhoundCarEngines = new Bloodhound({
	queryTokenizer: Bloodhound.tokenizers.whitespace,
	datumTokenizer: Bloodhound.tokenizers.whitespace,
	remote: {
		url: '/cars/json/?type=engine&brand=Mitsubishi&query=%QUERY',
		wildcard: '%QUERY',
		filter: function (list) {
			return $.map(list.items, function (item) {
				return {name: item.text};
			});
		}
	}
});

var bloodhoundCarEquipmentLevels = new Bloodhound({
	queryTokenizer: Bloodhound.tokenizers.whitespace,
	datumTokenizer: Bloodhound.tokenizers.whitespace,
	remote: {
		url: '/cars/json/?type=equipment_level&brand=Mitsubishi&query=%QUERY',
		wildcard: '%QUERY',
		filter: function (list) {
			return $.map(list.items, function (item) {
				return {name: item.text};
			});
		}
	}
});

var bloodhoundCarCodes = new Bloodhound({
	queryTokenizer: Bloodhound.tokenizers.whitespace,
	datumTokenizer: Bloodhound.tokenizers.whitespace,
	remote: {
		url: 'https://di.mitsubishi-motors.cz/rest/cz/getCarCodes/%QUERY',
		wildcard: '%QUERY',
		filter: function (list) {
			return $.map(list.data, function (item) {
				return {name: item.text};
			});
		}
	}
});

function carTypeahead() {
	$('.typeahead-car-exteriors').typeahead(null, {
		name: 'car-exteriors',
		displayKey: 'name',
		valueKey: 'name',
		source: bloodhoundCarExteriors
	});

	$('.typeahead-car-interiors').typeahead(null, {
		name: 'car-interiors',
		displayKey: 'name',
		valueKey: 'name',
		source: bloodhoundCarInteriors
	});

	$('.typeahead-car-engines').typeahead(null, {
		name: 'car-engines',
		displayKey: 'name',
		valueKey: 'name',
		source: bloodhoundCarEngines
	});

	$('.typeahead-car-equipment-levels').typeahead(null, {
		name: 'car-equipment-levels',
		displayKey: 'name',
		valueKey: 'name',
		source: bloodhoundCarEquipmentLevels
	});
};

function globalCarTypeahead() {
	$('.typeahead-car-codes').typeahead(null, {
		name: 'car-codes',
		displayKey: 'name',
		valueKey: 'name',
		source: bloodhoundCarCodes
	});
};

if ($('#frm-carForm-brand_id').val() == 1) {
	carTypeahead();
}

$('#frm-carForm-brand_id').off('change').on('change', function () {
	if ($('#frm-carForm-brand_id').val() == 1) {
		carTypeahead();
	}
	else {
		$('.typeahead-car-exteriors').typeahead('destroy');
		$('.typeahead-car-interiors').typeahead('destroy');
		$('.typeahead-car-engines').typeahead('destroy');
		$('.typeahead-car-equipment-levels').typeahead('destroy');
	}
});


function removeDiacritics(input) {
	var text = $(input).val();
	text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	$(input).val(text);

	$(input).keyup();
}


function datagridFilters() {

	selectInit();

	$('input[data-provide="datepicker"]').datepicker({
		weekStart: 1,
		language: 'cs'
	});

	$('input[data-provide="datepicker"]').datepicker().on('changeDate', function(e) {
		e.currentTarget.focus();
	});


	$('.datagrid-toolbar .filter').click(function() {
		$('.datagrid table thead .bootstrap-select div.dropdown-menu').each(function(e){
			$(this).removeClass('show');
		});
	});

	$(document).on('keydown', '.datagrid thead', function(e) {
		var code = e.keyCode || e.which;
		if (code == 13) {
			$(this).parents('form:first').submit();
		}

		$('.datagrid table thead .bootstrap-select div.dropdown-menu').each(function(e){
			$(this).removeClass('show');
		});
	});
}

$.nette.ext('bs-modal', {

	init: function() {
		// if the modal has some content, show it when page is loaded
		var $modal = $('#modal');
		if ($modal.find('.modal-content').html().trim().length !== 0) {
			$modal.modal('show');
		}
	},
	success: function (jqXHR, status, settings) {

		if (typeof settings.responseJSON.snippets != 'undefined') {
			var $snippet = settings.responseJSON.snippets['snippet--modal'];
		}
		if (!$snippet) {
			return;
		}

		var $modal = $('#modal');
		if ($modal.find('.modal-content').html().trim().length !== 0) {
			$modal.modal('show');
		} else {
			$modal.modal('hide');
		}
	}
});

function returnUpdatedUser(id, title)
{
	document.getElementById('currentLeadUserId').value = id;
	document.getElementById('currentLeadUserName').getElementsByTagName('span')[0].innerText = title;
	$('#modal').modal('hide');
}
